import "es6-promise/auto";
import "babel-polyfill";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import enLocale from "element-ui/lib/locale/lang/en"; //引入Element UI的英文包
import zhLocale from "element-ui/lib/locale/lang/zh-CN"; //引入Element UI的中文包
import _ from "lodash";
import VeeValidate from "vee-validate";
import App from "./App";
import router from "./router";
import VuesticPlugin from "@/vuestic-theme/vuestic-plugin";
import { getStoredLocale } from "./i18n/localeStorage";
import YmapPlugin from "vue-yandex-maps";
import VueBus from "./assets/vueBus";
import { request, saveShoplazzaLoginRedirect, consumeShoplazzaLoginRedirect } from "@/utils/utils";
// 引入完整的echarts
import echarts from "echarts";
import store from "./store/index";
import "./i18n";
import pageName from "./components/NewUser/pageNames";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import SessionStorage from "@/plugins/sessionStorage";
// import 'bootstrap/dist/css/bootstrap.css' // 开发环境下样式有问题 故注掉
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(SessionStorage);

Vue.prototype._ = _;
Vue.prototype.$echarts = echarts;
Vue.use(VueBus);
Vue.use(VuesticPlugin);
Vue.use(YmapPlugin);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate, { fieldsBagName: "formFields" });

axios.defaults.baseURL = process.env.VUE_APP_API_ROOT;
// 默认超时时间
axios.defaults.timeout = 50000;

Vue.prototype.$ajax = axios;
Vue.config.productionTip = false;
Vue.config.devtools = true;
const ELEMENT_LOCALES = {
  en: enLocale,
  zh: zhLocale,
};
const locale = ELEMENT_LOCALES[getStoredLocale()] || enLocale;
Vue.use(ElementUI, { locale });

window.isRefreshing = false;
var refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}
function onRefreshed(token) {
  refreshSubscribers.map((cb) => cb(token));
  refreshSubscribers = [];
}
function canRefreshToken() {
  var effectiveDuration = localStorage.getItem("startTime")
    ? Math.floor(Number(localStorage.getItem("startTime")) / 1e3) +
      Number(localStorage.getItem("sessionTime"))
    : "";
  if (effectiveDuration) {
    var nowTime = Math.floor(new Date().getTime() / 1e3);
    var willExpired = true;
    if (effectiveDuration - nowTime > 0) {
      var diffTime = Math.floor((effectiveDuration - nowTime) / 60);
      // willExpired = diffTime < 10 && diffTime >= 5;
      willExpired = diffTime < 10;
    } else {
      willExpired = false;
    }
    return willExpired;
  }
  return false;
}
function isTokenExpired() {
  var effectiveDuration = localStorage.getItem("startTime")
    ? Math.floor(Number(localStorage.getItem("startTime")) / 1e3) +
      Number(localStorage.getItem("sessionTime"))
    : "";
  if (effectiveDuration) {
    var nowTime = Math.floor(new Date().getTime() / 1e3);
    var willExpired = true;
    if (effectiveDuration - nowTime > 0) {
      var diffTime = Math.floor((effectiveDuration - nowTime) / 60);
      willExpired = diffTime - 5 >= 0;
    } else {
      willExpired = false;
    }
    return willExpired;
  }
  return false;
}

function isRefreshTokenExpired() {
  let startTime = parseInt(localStorage.getItem("startTime"));
  let nowTime = new Date().getTime();
  let stamp = nowTime - startTime;
  let minutes = Math.floor(stamp / 6e4);
  return 1430 - minutes >= 10 ? true : false;
}

function goLogin() {
  router.replace({ path: "/" });
}
function logoutSession() {
  var currToken = localStorage.getItem("Authorization");
  if (currToken) {
    axios({
      method: "delete",
      url: `api/dashboard/logout?access_token=${currToken}`,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then((res) => {
        var fg = res.data;
        if (fg === true) {
          localStorage.removeItem("Authorization");
        }
      })
      .catch((err) => {});
  }
}
function getNewToken() {
  let refreshToken = localStorage.getItem("refresh_token");
  axios({
    method: "post",
    url: `api/dashboard/refresh?refresh_token=${refreshToken}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((res) => {
      window.isRefreshing = false;
      var respData = res.data;
      if (respData.code === "10000") {
        var tokenVo = {
          Authorization: respData.data.access_token,
          refreshToken: respData.data.refresh_token,
        };
        var newToken = tokenVo.Authorization;
        localStorage.setItem("Authorization", newToken);
        localStorage.setItem("sessionTime", respData.data.expires_in);
        localStorage.setItem("startTime", new Date().getTime());
        localStorage.setItem("refresh_token", tokenVo.refreshToken);
        onRefreshed(newToken);
      } else {
        if (respData.code === "20002") {
          fetchNewToken();
        }
      }
    })
    .catch((err) => {
      localStorage.clear();
      goLogin();
    });
}
function fetchNewToken() {
  let refreshToken = localStorage.getItem("refresh_token");
  axios({
    method: "post",
    url: `api/dashboard/refresh?refresh_token=${refreshToken}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((res) => {
      var respData = res.data;
      if (respData.code === "10000") {
        var tokenVo = {
          Authorization: respData.data.access_token,
          refreshToken: respData.data.refresh_token,
        };
        var newToken = tokenVo.Authorization;
        localStorage.setItem("Authorization", newToken);
        localStorage.setItem("sessionTime", respData.data.expires_in);
        localStorage.setItem("startTime", new Date().getTime());
        localStorage.setItem("refresh_token", tokenVo.refreshToken);
        onRefreshed(newToken);
      } else {
        goLogin();
      }
    })
    .catch((err) => {
      goLogin();
    });
}

axios.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem('userData') || '{}';
    const userDataObject = JSON.parse(userData)
    let { merchantNoSelected } = userDataObject
    if (merchantNoSelected) {
      config.headers.merchant_no = merchantNoSelected
    }

    config.CancelToken = window.currentSource && window.currentSource.token;
    // if (canRefreshToken() && isTokenExpired() && isRefreshTokenExpired()) {
    // if (canRefreshToken() && isTokenExpired()) {
    if (canRefreshToken()) {
      // token过期时，跳转登录页面
      localStorage.clear();
      location.href = "/auth/login";
      // if (!window.isRefreshing) {
      //   logoutSession();
      //   fetchNewToken();
      // }
      // window.isRefreshing = true;
    }
    if (config.url.indexOf("access_token=null") > 0) {
      return Promise.reject(config);
    } else {
      return config;
    }
  },
  (err) => {
    return Promise.reject(err);
  }
);

// 异步请求后，判断token是否过期
axios.interceptors.response.use(
  (response) => {
    // if (canRefreshToken() && isTokenExpired() && isRefreshTokenExpired()) {
    // if (canRefreshToken() && isTokenExpired()) {
    if (canRefreshToken()) {
      // token过期时，跳转登录页面
      localStorage.clear();
      location.href = "/auth/login";
      // if (!window.isRefreshing) {
      //   logoutSession();
      //   fetchNewToken();
      // }
      // window.isRefreshing = true;
    }
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status == 401) {
        // token过期时，跳转登录页面
        localStorage.clear();
        location.href = "/auth/login";
        // let config = error.config;
        // if (!window.isRefreshing) {
        //   getNewToken(config);
        // }
        // window.isRefreshing = true;
        // var retry = new Promise((resolve, reject) => {
        //   subscribeTokenRefresh(updateToken => {
        //     config.url.split("access_token=")[0] +
        //       "?access_token=" +
        //       updateToken;
        //     resolve(config);
        //   });
        // });
        // return retry;
      }
    }
    return Promise.reject(error);
  }
);

router.beforeEach(function (to, from, next) {
  const source = window.currentSource;
  source && source.cancel && source.cancel("cancel this request");
  const newSource = axios.CancelToken.source();
  window.currentSource = newSource;
  let token = localStorage.getItem("Authorization");
  if (to.meta.needLogin) {
    //meed login
    if (to.meta.permName) {
      if (
        store.getters.user.permissions &&
        store.getters.user.permissions[to.meta.permName]
      ) {
        // there is permission rule in store
        store.getters.user.permissions[to.meta.permName]
          ? next()
          : next({ name: "login" });
      } else if (token) {
        // there is NO permission rule in store but there is Token
        let permissions = {
          // [pageName.transactions]: false,
          [pageName.report]: false,
          [pageName.appManagement]: false,
          [pageName.finance]: false,
          [pageName.merchantKyc]: false,
          [pageName.userManagement]: false,
          [pageName.wayBill]: false,
          [pageName.virtualAccount]: false,
          [pageName.download]: false,
        };
        request({
          method: "post",
          url: "api/dashboard/app/user/query?access_token=" + token,
        })
          .then((response) => {
            if (response.data.code == "10000") {
              let isAdmin =
                response.data.data.role === "MERCHANT_ADMIN" ? true : false;
              if (isAdmin) {
                for (let i in permissions) {
                  permissions[i] = true;
                }
                permissions[pageName.finance] = response.data.data.show_finance
                  ? true
                  : false;
                permissions[pageName.virtualAccount] = response.data.data
                  .show_virtual_account
                  ? true
                  : false;
              } else {
                response.data.data.permission.forEach((item) => {
                  if (permissions[item.name] !== undefined) {
                    permissions[item.name] =
                      item.privileges[0] === "View" ? true : false;
                  }
                });
                if (!response.data.data.show_finance) {
                  this.permissions[pageName.finance] = false;
                }
                if (!response.data.data.show_virtual_account) {
                  this.permissions[pageName.virtualAccount] = false;
                }
              }

              store.commit("setUser", {
                info: response.data,
                permissions: permissions,
              });
              store.getters.user.permissions[to.meta.permName]
                ? next()
                : next({ name: "login" });
            } else {
              next({ name: "login" });
            }
          })
          .catch((err) => {
            next({ name: "login" });
          });
      } else {
        next({ name: "login" });
      }
    } else if (!token) {
      // Shoplazza 等独立外部页：仅校验登录，不走系统权限；未登录时保存回跳地址
      // 必须带 state，才视为有效 Shoplazza 绑定入口
      if (to.meta.externalPlugin && to.query && to.query.state) {
        saveShoplazzaLoginRedirect(to.fullPath);
        next({
          name: "login",
          query: { redirect: to.fullPath },
        });
        return;
      }
      next({ name: "login" });
    } else {
      next();
    }
  } else if (token) {
    // 已登录访问登录页时：仅 Shoplazza 回跳生效，不影响原有进首页逻辑
    if (to.name === "login") {
      const redirect = consumeShoplazzaLoginRedirect(to.query);
      if (redirect) {
        next(redirect);
        return;
      }
    }
    // 获取到token跳转首页
    // next({ name: "Dashboard" })
    next({ name: "PaymentOrder" })
  } else {
    next();
  }
});

// if (process.env.VUE_APP_MODE === "development") {
//   //开发环境下的执行操作
//   console.log("开发环境下的API地址：---》" + process.env.VUE_APP_API_ROOT);
// } else if (process.env.VUE_APP_MODE === "test") {
//   //测试环境下的执行操作
//   console.log("测试环境下的API地址：---》" + process.env.VUE_APP_API_ROOT);
// } else {
//   //生产环境下的执行操作
//   console.log("生产环境");
// }

router.afterEach((to, from) => {
  store.commit("setLoading", false);
  // 重新刷新加载google recaptura
  if (from.name !== null && from.name !== "login") {
    if (to.name === "login") {
      window.location.reload();
    }
  }
});

let vm = new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
Vue.use(vm);
